import is from '@sindresorhus/is';
import { useCallback } from 'react';

import { useSnackbars } from '../../../../../app/error-handling/SnackBars';

// Guidance risk (JSA0011) and duplicate section names (JSA0012) carry a user-facing explanation.
const explainedErrorCodes = new Set(['JSA0011', 'JSA0012']);

export const getJobProfileTemplateErrorMessage = (error: unknown): string | undefined => {
    if (
        !is.object(error) ||
        !('errorCode' in error) ||
        !is.string(error.errorCode) ||
        !explainedErrorCodes.has(error.errorCode) ||
        !('message' in error) ||
        !is.string(error.message)
    ) {
        return undefined;
    }

    const errorCodePrefix = `${error.errorCode}:`;
    const message = error.message.startsWith(errorCodePrefix)
        ? error.message.slice(errorCodePrefix.length).trim()
        : error.message.trim();

    return is.nonEmptyString(message) ? message : undefined;
};

export const useJobProfileTemplateErrorSnackbar = (): ((error: unknown) => void) => {
    const { showErrorSnackbar, showErrorTextSnackbar } = useSnackbars();

    return useCallback(
        (error: unknown): void => {
            const errorMessage = getJobProfileTemplateErrorMessage(error);

            if (is.undefined(errorMessage)) {
                showErrorSnackbar(error);
                return;
            }

            showErrorTextSnackbar(errorMessage);
        },
        [showErrorSnackbar, showErrorTextSnackbar],
    );
};
